module.exports = __webpack_public_path__ + "static/media/mars-stroke.4ccfc954.svg";